import React from 'react';
import SvgIcon from '../library/SvgIcon/SvgIcon.js';

import './style.scss';

const SocialLinks = () => {
  return (
    <ul className="network__list">
      <li className="network__item">
        <a href="https://github.com/mark-vb-austin">
          <SvgIcon icon="github" width="30px" height="30px" />
        </a>
      </li>
      <li className="network__item">
        <a href="https://www.linkedin.com/in/austinmark/">
          <SvgIcon icon="linkedin" width="30px" height="30px" />
        </a>
      </li>
    </ul>
  );
};

export default SocialLinks;
